module.exports = __webpack_public_path__ + "static/media/share-theme.894c0478.svg";